module.exports = __webpack_public_path__ + "img/15ne.00ee57bc.svg";